import React from "react";
import { type ListTemplateLayout } from "./types";
import { useLocalStorage } from "utilities/usehooks";
import { PhosphorListBulletsButton, PhosphorSquaresFourButton } from "components/Atoms/PhosphorIconButton";
import { HorizontalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";

type LayoutType = "card" | "table";

interface LayoutLocalStorage {
  layoutType: LayoutType
}

interface LayoutToggleProps {
  selectedLayout: LayoutType
  toggleLayout: (() => void) | null
}

const LayoutToggle = ({ selectedLayout, toggleLayout }: LayoutToggleProps) => {
  return <div className="flex gap-small">
    <PhosphorListBulletsButton
      {...HorizontalKeyboardNavigationGroup("paginationRow")}
      onClick={selectedLayout === "card" ? () => { toggleLayout(); } : null}
      selectedStyle={selectedLayout === "table" ? "purple-bg" : null}
      layout="in-square"
    />
    <PhosphorSquaresFourButton
      {...HorizontalKeyboardNavigationGroup("paginationRow")}
      onClick={selectedLayout === "table" ? () => { toggleLayout(); } : null}
      selectedStyle={selectedLayout === "card" ? "purple-bg" : null}
      layout="in-square"
    />
  </div>;
};

export const useLayout = <TItem extends server.dto.IHasObjectPermissions>(
  layout: ListTemplateLayout<TItem>
) => {
  if (layout.type !== "both") {
    return { layout, layoutButtons: null };
  }

  const key = `layout:${layout.toggleCacheKey}-list`;
  const [selectedLayout, setSelectedLayout] = useLocalStorage<LayoutLocalStorage>(key, { layoutType: "card" });

  const toggleLayout = () => {
    setSelectedLayout(prev => prev.layoutType === "table" ? { layoutType: "card" } : { layoutType: "table" });
  };

  const layoutConfig = selectedLayout.layoutType === "card" ? { type: "card", sections: layout.sections } : { type: "table", hideHeader: false, columns: layout.columns };

  return { layout: layoutConfig, layoutButtons: <LayoutToggle selectedLayout={selectedLayout.layoutType} toggleLayout={toggleLayout} /> };
};
